import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from 'src/app/services/alert.service';
import { Alert } from 'src/app/shared/models/Alert';

@Component({
  selector: 'app-alert-page',
  templateUrl: './alert-page.component.html',
  styleUrls: ['./alert-page.component.css']
})
export class AlertPageComponent implements OnInit {

  constructor(private alertService: AlertService, private toastr: ToastrService) { }

  ngOnInit() {
    this.alertService.getAlerts().subscribe(
      (alert: Alert) => {
        this.toastr[alert.type](alert.body);
      });
  }
}
